module.exports = {

  adverseTermsLists: (Api) ->
    return Api.AdverseTerms.query().$promise

  countries: (Api) ->
    return Api.Country.query().$promise

  searchTermTypes: (Api) ->
    Api.SearchTermTypes.query().$promise

  languages: (Api) ->
    return Api.Language.query().$promise

  managedUsers: (Api, $rootScope) ->
    return Api.SimpleManagedUser.query({is_active: true}).$promise

  processes: (Api) ->
    return Api.Processes.query().$promise

  states: (Api) ->
    return Api.State.query().$promise

  user: (User) ->
    return User.resolve()

  workflowTemplatesLoad: (Api) ->
    return Api.WorkflowTemplate.query().$promise

  workflowTemplates: (template, workflowTemplatesLoad, user) ->
    return template.filterWorkflowTemplatesByClientGroup(workflowTemplatesLoad, user.client_groups)

}
